import API from './resources'

const actions = {
  async disableCommunication({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.disableCommunication(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async updateCommunication({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.updateCommunication(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async postCommunication({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.postCommunication(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async getCommunications({ commit, state }, payload) {
    try {
      if (state.is_active === null)  {
        const response = await API.getAllCommunications(
          state.page,
          state.size,
          state.product_id,
          state.search_text,
          payload.token
          )

        commit('SET_COMMUNICATIONS_LIST', response.data)
        commit('SET_COMMUNICATIONS_PAGINATION', response.data)
      } else {
        const response = await API.getFilteredCommunications(
          state.is_active,
          state.page,
          state.size,
          state.product_id,
          state.search_text,
          payload.token
        )
        commit('SET_COMMUNICATIONS_LIST', response.data)
        commit('SET_COMMUNICATIONS_PAGINATION', response.data)
      }
    } catch (error) {
      return error
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/communication/actions.js